import { Injectable, inject } from "@angular/core";
import { DialogService } from "@kpx/quickscan";

@Injectable({
  providedIn: "root",
})
export class ActionService {
  private dialog: DialogService;

  public constructor() {
    this.dialog = inject(DialogService);
  }

  public handleClick(event: MouseEvent): void {
    if (event.target instanceof HTMLSpanElement) {
      const { dataset } = event.target;
      if (dataset["action"] == "true") {
        event.stopImmediatePropagation();
        event.preventDefault();

        const { actionType, actionValue } = dataset;
        if (!actionType || !actionValue) throw new Error("Action Type or Value not set");

        switch (actionType) {
          case "popup":
            this.dialog.handleDialog(actionValue);
            break;

          default:
            console.error("Undefined action =>", { actionType, actionValue, target: event.target });
        }
      }
    }
  }
}
